<template>
  <table class="custom-table">
    <tbody>
      <tr>
        <td
          v-for="day of daybyday"
          :key="day.id"
          align="center"
          class="custom-chart"
        >
          <vue-highcharts
            type="chart"
            :ref="`vchart-${day.name}`"
            :options="getOptions(day.ratings, day.colors)"
            :redrawOnUpdate="true"
            :oneToOneUpdate="false"
            :animateOnUpdate="true"
          />
          <span :id="`day-${day.name}`">
            <a :href="`#pictures-${day.name}`" class="custom-link">{{
              day.letter
            }}</a>
          </span>
        </td>
      </tr>
      <tr class="custom-row">
        <td v-for="day of daybyday" :key="day.id" align="center">
          <span :id="`count-${day.name}`" class="custom-count">{{
            day.count
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapGetters } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'nutrition-daybyday',
  components: {
    VueHighcharts,
  },
  props: {
    progress: {
      type: [Array, Number, String],
      default: 0,
    },
  },
  data() {
    return {
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
      ],
    }
  },
  computed: {
    ...mapGetters('nutrition', ['nutrition']),
    daybyday() {
      let _data = []
      if (this.nutrition) {
        for (var i = 0; i < this.days.length; i++) {
          let day = this.days[i]
          let ratings = []
          let colors = ['#707070']
          if (this.nutrition.food.days) {
            ratings.push({
              name: 'good',
              y: this.nutrition.food.days[day].goodPct,
            })
            ratings.push({
              name: 'neutral',
              y: this.nutrition.food.days[day].neutralPct,
            })
            ratings.push({
              name: 'bad',
              y: this.nutrition.food.days[day].badPct,
            })
            // #169900
            colors = ['#169900', '#707070', '#c42626']
          } else {
            ratings.push({ name: 'none', y: 100 })
            colors = ['#707070']
          }
          _data.push({
            id: i,
            name: day,
            letter: day.substring(0, 1).toUpperCase(),
            ratings: ratings,
            colors: colors,
            count: this.nutrition.food.days[day].count,
          })
        }
      }
      return _data
    },
  },
  methods: {
    getOptions(ratings, colors) {
      let options = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: 140,
          width: 140,
          className: 'custom-highcharts',
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
            },
          },
        },
        title: {
          text: '',
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        colors: colors,
        series: [
          {
            type: 'pie',
            innerSize: '75%',
            data: ratings,
          },
        ],
      }
      return options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-table {
  width: 100%;
}
.custom-row {
  position: relative;
  top: -20px;
}
.custom-chart {
  position: relative;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
  div {
    position: relative;
    bottom: 0px;
  }
  span {
    position: absolute;
    text-align: center;
    margin: 0 auto;
    font-size: 2.3em;
    left: 0;
    top: 40px;
    width: 100%;
  }
}
.custom-count {
  position: relative;
  text-align: center;
  margin: 0 auto;
  font-size: 1.4em;
  top: 0;
}
.custom-link {
  text-decoration: none;
  cursor: pointer;
}
</style>
